import React, { FunctionComponent, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { PageLayout } from '../../common/PageLayout';
import { useSelectWithParams } from '../../../../utils/selector.utils';
import { UserAvatar } from '../../common/UserAvatar';
import { IUser } from '../../../../app/resource/user/user.types';
import { IUserReportsPageProps } from './types';
import Topbar from '../Topbar';
import { fetchUserReports } from '../../../../app/page/page-storage/reports/reports.actions';
import { reportPageSelectors } from '../../../../app/page/page-storage/reports/reports.selectors';
import { userSelectors } from '../../../../app/resource/user/user.selectors';
import KpisMetrics from '../KpisMetrics';
import QuarterlyInitiatives from '../QuarterlyInitiative';
// import DoughnutMetricCards from '../DoughnutMetricCards';
import { initialUserPage } from '../../../../app/page/users/users.actions';
import MeetingMemberDoughnutMetricCards from '../MeetingMemberReportPage/MeetingMemberDoughnutMetricCards';

const UserReportsPage: FunctionComponent<IUserReportsPageProps> = () => {
  const dispatch = useDispatch();
  const { userId } = useParams<{ userId: IUser['id'] }>();
  const user = useSelectWithParams(userSelectors.selectResourceById, userId);

  useEffect(() => {
    if (userId) {
      dispatch(initialUserPage());
      dispatch(fetchUserReports(userId));
    }
  }, [dispatch, userId]);

  const report = useSelectWithParams(reportPageSelectors.selectUserReportByUserId, userId);
  if (!report) {
    return null;
  }

  return (
    <PageLayout smallSidebar>
      <div className="row mb-2">
        <div className="col-12">
          <div className="panel">
            <div className="panel-header small-header no-border pb-0 mb-1">
              <h2>User Reports</h2>
            </div>
            <div className="cards-container-overflow meeting-report">
              <div className="cards-container">
                <div className="panel">
                  <div className="panel-body pt-0 ho-hover px-0">
                    <div className="border-radius-1 lightGray-bg p-2">
                      <div className="row">
                        <div className="col">
                          <Topbar memberId={userId} />
                          {report && (
                            <>
                              <div className="panel my-1 p-2">
                                <div className="flex align-center" style={{ height: 120 }}>
                                  {user && (
                                    <>
                                      <UserAvatar userInfo={user} size="100" />
                                      <div className="flex flex-column ml-2" style={{ flex: 1 }}>
                                        <div className="flex align-center justify-between border-bottom py-1">
                                          <div className="text-left bold">{`${user.firstName} ${user.lastName}`}</div>
                                        </div>
                                        <div className="flex align-center justify-between py-1">
                                          <div className="text-left">
                                            <span>{user.jobTitle}</span>
                                          </div>
                                        </div>
                                      </div>
                                      <div className="flex align-center flex-column">
                                        <div className="avg-score">
                                          {report.attendance.avgScore > 0
                                            ? Math.round(report.attendance.avgScore * 10) / 10
                                            : '-'}
                                        </div>
                                        <span className="ml-1 mt-1">Average Meeting Score</span>
                                      </div>
                                    </>
                                  )}
                                </div>
                              </div>
                              <MeetingMemberDoughnutMetricCards report={report} />
                              <QuarterlyInitiatives goalList={report.goals.list} />
                              <KpisMetrics kpis={report.kpis} />
                            </>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </PageLayout>
  );
};

export default UserReportsPage;
